import React, { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import ReservationDateSelect, {
  ReservationDateSelectProps,
} from 'ui/utils/ReservationDateSelect'
import SelectFrames from 'ui/utils/SelectFrame'
import { ReservationDeadlineTimings, ReservationFrameProps } from 'types/med'

const ReservationFrameSelectForm: React.FC<{
  departmentId: number
  startFormName: string
  endFormName: string
  reservableDates: ReservationDateSelectProps['reservableDates']
  reservableDeadlineTiming?: ReservationDeadlineTimings | null
  minDate: Date
  maxDate: Date
  minDateMessage: string
  maxDateMessage: string
  onSetDate: (date: Date) => void
  onChangeCalenderMonth: ReservationDateSelectProps['onChangeCalenderMonth']
  frames?: ReservationFrameProps[]
  hasError?: boolean
}> = ({
  departmentId,
  startFormName,
  endFormName,
  reservableDates,
  reservableDeadlineTiming,
  onSetDate,
  minDate,
  maxDate,
  minDateMessage,
  maxDateMessage,
  onChangeCalenderMonth,
  frames,
  hasError,
}) => {
  const { setValue } = useFormContext()

  const [selectedDate, setSelectedDate] = useState<Date>(minDate)

  const [currentFrame, setCurrentFrame] = useState<
    ReservationFrameProps | undefined
  >()

  useEffect(() => {
    if (currentFrame) {
      setValue(startFormName, currentFrame.frame_datetime_start, {
        shouldValidate: true,
        shouldDirty: true,
      })
      setValue(endFormName, currentFrame.frame_datetime_end, {
        shouldValidate: true,
        shouldDirty: true,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFrame])

  useEffect(() => {
    // NOTE:科目を変えたらリセットする
    if (currentFrame) {
      setValue(startFormName, undefined, {
        shouldValidate: true,
      })
      setValue(endFormName, undefined, {
        shouldValidate: true,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departmentId])

  useEffect(() => {
    onSetDate(selectedDate)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate])

  return (
    <>
      <ReservationDateSelect
        reservableDates={reservableDates}
        reservableDeadlineTiming={reservableDeadlineTiming}
        selectedDate={selectedDate}
        onSelect={setSelectedDate}
        minDate={minDate}
        minDateMessage={minDateMessage}
        maxDate={maxDate}
        maxDateMessage={maxDateMessage}
        onChangeCalenderMonth={onChangeCalenderMonth}
      />
      <SelectFrames
        departmentId={departmentId}
        deadlineTiming={reservableDeadlineTiming}
        frames={frames}
        onSelect={setCurrentFrame}
        hasError={hasError}
      />
    </>
  )
}

export default ReservationFrameSelectForm
